export const userService = {
    login,
    addOrder,
    logout
};

function addOrder(form) {
    const user = localStorage.getItem('user');
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept' : 'application/json' },
        body: JSON.stringify({ form, user })
    };

    return fetch(`https://ordini.saegsrl.com/ajax/action.php?a=add`, requestOptions).then(handleResponse);
}

function login(username, password) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password })
    };

    return fetch(`https://ordini.saegsrl.com/ajax/action.php?a=login`, requestOptions)
        .then(handleResponse)
        .then(user => {
            // login successful if there's a jwt token in the response
            if (user.token) {
                // store user details and jwt token in local storage to keep user logged in between page refreshes
                localStorage.setItem('user', JSON.stringify(user));
            }

            return user;
        });
}

function logout() {
    // remove user from local storage to log user out
    localStorage.removeItem('user');
}

function handleResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok || data.error) {
            if (response.status === 401) {
                // auto logout if 401 response returned from api
                logout();
                location.reload(true);
            }

            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }

        return data;
    });
}